import * as React from 'react';



export default class UserPic extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 32 32" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g xmlns="http://www.w3.org/2000/svg">
            <circle className="st0" cx="16" cy="16" r="15"/>
            <g>
                <circle className="strokeColor" fill="currentColor" cx="15.8" cy="11.5" r="3.8"/>
                <path className="strokeColor" fill="currentColor" d="M25.5,21.4c-1.9-4-5-6.1-9.5-6.1s-7.7,2-9.5,6.1c-0.5,1,0,2.2,1,2.7c0.3,0.1,0.5,0.2,0.8,0.2h15.4    c1.1,0,2-0.9,2-2C25.7,21.9,25.6,21.6,25.5,21.4z"/>
            </g>
        </g>
      </svg>
    )
  }
}
